import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
    selector: 'tran-ui-content-wrapper',
    templateUrl: './content-wrapper.component.html',
    imports: [NgTemplateOutlet],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContentWrapperComponent {
    public readonly noLeftSpacing = input<boolean>(false);
    public readonly noRightSpacing = input<boolean>(false);

    protected readonly spacingClasses = computed(() => {
        const leftClass = this.noLeftSpacing() ? 'ml-0' : 'ml-5 sm:!ml-20 xl:!ml-auto';
        const rightClass = this.noRightSpacing() ? 'mr-0' : 'mr-5 sm:!mr-20 xl:!mr-auto';
        return `${leftClass} ${rightClass} max-w-7xl`;
    });
}
